interface SEOSchemaProps {
  type: 'website' | 'article' | 'organization' | 'faq' | 'breadcrumb';
  data?: Record<string, unknown>;
}

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '偷拍自拍技巧大全',
  url: 'https://999vv.cn',
  description: '专注于自然感自拍摄影的中文内容平台，分享构图技巧、光线运用、设备推荐及后期处理教程。',
  email: 'hello@candid-selfie.cn',
};

function getWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '偷拍自拍技巧大全',
    url: 'https://999vv.cn',
    description: '偷拍自拍技巧大全——分享最实用的自然感自拍方法、手机自拍构图技巧、光线运用秘诀及后期处理教程。',
    inLanguage: 'zh-CN',
  };
}

function getWebPageSchema(name: string, description: string, url: string, breadcrumbData?: Record<string, unknown>) {
  const page: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '偷拍自拍技巧大全',
      url: 'https://999vv.cn',
    },
  };
  if (breadcrumbData) {
    page.breadcrumb = breadcrumbData;
  }
  return page;
}

function getBreadcrumbSchema(items: { name: string; url?: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url || undefined,
    })),
  };
}

function getArticleSchema(article: {
  title: string;
  description: string;
  url: string;
  datePublished: string;
  dateModified: string;
  imageUrl: string;
  authorName: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    url: article.url,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    image: article.imageUrl,
    author: {
      '@type': 'Person',
      name: article.authorName,
    },
    publisher: {
      '@type': 'Organization',
      name: '偷拍自拍技巧大全',
    },
    inLanguage: 'zh-CN',
  };
}

function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export { getWebsiteSchema, getWebPageSchema, getBreadcrumbSchema, getArticleSchema, getFAQSchema, organizationSchema };

export default function SEOSchema({ type, data }: SEOSchemaProps) {
  let schema: Record<string, unknown> | null = null;

  switch (type) {
    case 'organization':
      schema = organizationSchema;
      break;
    case 'website':
      schema = getWebsiteSchema();
      break;
    case 'article':
      if (data) schema = getArticleSchema(data as never);
      break;
    case 'faq':
      if (data) schema = getFAQSchema(data as { question: string; answer: string }[]);
      break;
    default:
      break;
  }

  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}